import SideNav from './side-nav';

export default SideNav;
